export enum NotificationSettingsMode {
  CLIENT = 'CLIENT',
  OWN = 'OWN',
}
